import React, { useState } from 'react';
import {
    View,
    Text,
    TextInput,
    TouchableOpacity,
    StyleSheet,
    KeyboardAvoidingView,
    Platform,
    ScrollView,
    ActivityIndicator,
    StatusBar,
    Image,
} from 'react-native';
import { COLORS, APP_INFO } from '../config';
import { useAuth } from '../context/AuthContext';
import { useCustomAlert } from '../components/CustomAlert';

export default function LoginScreen({ navigation }) {
    const [telepon, setTelepon] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const { alert } = useCustomAlert();

    const handleLogin = async () => {
        if (!telepon || !password) {
            alert('Error', 'Telepon dan password harus diisi!');
            return;
        }

        setLoading(true);
        const result = await login(telepon, password);
        setLoading(false);

        if (!result.success) {
            alert('Login Gagal', result.message || 'Username atau password salah!');
        }
    };

    return (
        <KeyboardAvoidingView
            behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
            style={styles.container}
        >
            <StatusBar barStyle="dark-content" backgroundColor={COLORS.bgDarker} />
            <ScrollView
                contentContainerStyle={styles.scrollContent}
                keyboardShouldPersistTaps="handled"
                showsVerticalScrollIndicator={false}
            >
                {/* Header */}
                <View style={styles.header}>
                    <Image
                        source={require('../../assets/logo.png')}
                        style={styles.logo}
                        resizeMode="contain"
                    />
                    <Text style={styles.brandName}>{APP_INFO.fullName}</Text>
                    <Text style={styles.tagline}>GAMING MEMBER CLUB</Text>
                </View>

                {/* Login Form */}
                <View style={styles.formCard}>
                    <Text style={styles.formTitle}>Masuk</Text>
                    <Text style={styles.formSubtitle}>Selamat datang kembali!</Text>

                    <View style={styles.inputGroup}>
                        <Text style={styles.label}>Nomor Telepon</Text>
                        <TextInput
                            style={styles.input}
                            placeholder="08xxxxxxxxxx"
                            placeholderTextColor={COLORS.textMuted}
                            keyboardType="phone-pad"
                            value={telepon}
                            onChangeText={setTelepon}
                        />
                    </View>

                    <View style={styles.inputGroup}>
                        <Text style={styles.label}>Password</Text>
                        <TextInput
                            style={styles.input}
                            placeholder="Masukkan password"
                            placeholderTextColor={COLORS.textMuted}
                            secureTextEntry
                            value={password}
                            onChangeText={setPassword}
                        />
                    </View>

                    <TouchableOpacity
                        style={[styles.button, loading && styles.buttonDisabled]}
                        onPress={handleLogin}
                        disabled={loading}
                        activeOpacity={0.8}
                    >
                        {loading ? (
                            <ActivityIndicator color="#fff" />
                        ) : (
                            <Text style={styles.buttonText}>Masuk</Text>
                        )}
                    </TouchableOpacity>

                    <TouchableOpacity
                        style={styles.forgotLink}
                        onPress={() => navigation.navigate('ForgotPassword')}
                    >
                        <Text style={styles.forgotLinkText}>Lupa Password?</Text>
                    </TouchableOpacity>
                </View>

                {/* Register Link */}
                <TouchableOpacity
                    style={styles.registerLink}
                    onPress={() => navigation.navigate('Register')}
                >
                    <Text style={styles.registerText}>
                        Belum punya akun?{' '}
                        <Text style={styles.registerLinkText}>Daftar</Text>
                    </Text>
                </TouchableOpacity>

                <Text style={styles.footer}>© 2026 {APP_INFO.fullName}</Text>
            </ScrollView>
        </KeyboardAvoidingView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: COLORS.bgDark,
    },
    scrollContent: {
        flexGrow: 1,
        justifyContent: 'center',
        padding: 24,
        paddingTop: 60,
        paddingBottom: 40,
    },
    header: {
        alignItems: 'center',
        marginBottom: 40,
    },
    logo: {
        width: 800,
        height: 120,
        marginBottom: -20,
        marginTop: -80,
    },
    brandName: {
        fontSize: 28,
        fontWeight: '800',
        color: COLORS.primary,
        marginBottom: 8,
    },
    tagline: {
        fontSize: 12,
        color: COLORS.textMuted,
        letterSpacing: 3,
    },
    formCard: {
        backgroundColor: COLORS.bgCard,
        borderRadius: 20,
        padding: 24,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.1,
        shadowRadius: 12,
        elevation: 5,
    },
    formTitle: {
        fontSize: 24,
        fontWeight: '700',
        color: COLORS.textPrimary,
        marginBottom: 4,
    },
    formSubtitle: {
        fontSize: 14,
        color: COLORS.textSecondary,
        marginBottom: 24,
    },
    inputGroup: {
        marginBottom: 16,
    },
    label: {
        color: COLORS.textSecondary,
        marginBottom: 8,
        fontWeight: '500',
        fontSize: 14,
    },
    input: {
        backgroundColor: COLORS.bgDark,
        borderRadius: 12,
        padding: 14,
        color: COLORS.textPrimary,
        fontSize: 15,
        borderWidth: 1,
        borderColor: COLORS.border,
    },
    button: {
        backgroundColor: COLORS.primary,
        borderRadius: 12,
        padding: 16,
        alignItems: 'center',
        marginTop: 8,
    },
    buttonDisabled: {
        opacity: 0.7,
    },
    buttonText: {
        color: '#fff',
        fontSize: 16,
        fontWeight: '600',
    },
    forgotLink: {
        marginTop: 16,
        alignItems: 'center',
    },
    forgotLinkText: {
        color: COLORS.primary,
        fontSize: 14,
        fontWeight: '500',
    },
    registerLink: {
        marginTop: 24,
        alignItems: 'center',
    },
    registerText: {
        color: COLORS.textSecondary,
    },
    registerLinkText: {
        color: COLORS.primary,
        fontWeight: '600',
    },
    footer: {
        textAlign: 'center',
        color: COLORS.textMuted,
        fontSize: 12,
        marginTop: 40,
    },
});
